import PropTypes from 'prop-types';

import { FAIcon } from 'lib/customPropTypes';

import { Icon } from '../Icons';

import NavLink from './NavLink';

const GlobalPrimaryLink = ({ children, icon, ...rest }) => (
  <NavLink {...rest}>
    <Icon icon={icon} size="lg" />
    <div className="mt-1">{children}</div>
  </NavLink>
);

GlobalPrimaryLink.propTypes = {
  children: PropTypes.string.isRequired,
  /**
   * Icon to display
   */
  icon: FAIcon.isRequired,
};

export default GlobalPrimaryLink;
